import { useRef } from "react";
import { ButtonToContent } from "@etframework/ui.components";
import { IconButton } from "@etframework/ui.components";

export const UpdateButtonToContent = ({
  label,
  children,
  htmlFor,
  iconCss,
  onRemove,
  onAdd,
}) => {
  const tagBTCRef = useRef(null);

  return (
    <ButtonToContent
      text={label}
      iconCss={"button-to-content-icon " + (iconCss ?? "fa-regular fa-plus")}
      buttonProps={{
        className: "btn-tertiary py-2 h-auto button-to-content-btn",
      }}
      ref={tagBTCRef}
      onClick={onAdd}
    >
      <div>
        <label htmlFor={htmlFor} className="fw-600 mb-2">
          {label}
        </label>
        <div className="d-flex flex-row gap-3 align-items-center">
          {children}
          <IconButton
            iconCss="fa-regular fa-circle-minus et-darkest-gray"
            onClick={() => {
              tagBTCRef.current.setShowButton(true);
              onRemove?.();
            }}
            isTerciary
          />
        </div>
      </div>
    </ButtonToContent>
  );
};
